export default __webpack_public_path__ + "static/FS2S-InHub-119-497ba4e4af772cf84d50233875a531b3.jpg";